import { render, staticRenderFns } from "./TransactionRecords.vue?vue&type=template&id=493269a1&scoped=true"
import script from "./TransactionRecords.vue?vue&type=script&lang=js"
export * from "./TransactionRecords.vue?vue&type=script&lang=js"
import style0 from "./TransactionRecords.vue?vue&type=style&index=0&id=493269a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493269a1",
  null
  
)

export default component.exports